module.exports = __webpack_public_path__ + "media/colleges/fastweb-volunteers-cbcd05a2.gif";